<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.2"
      d="M21 12.5937C21 14.3738 20.4722 16.1138 19.4832 17.5939C18.4943 19.0739 17.0887 20.2275 15.4442 20.9087C13.7996 21.5899 11.99 21.7681 10.2442 21.4208C8.49836 21.0735 6.89472 20.2164 5.63604 18.9577C4.37737 17.699 3.5202 16.0954 3.17294 14.3496C2.82567 12.6037 3.0039 10.7941 3.68509 9.1496C4.36628 7.50506 5.51983 6.09946 6.99987 5.11052C8.47992 4.12159 10.22 3.59375 12 3.59375C14.387 3.59375 16.6761 4.54196 18.364 6.22979C20.0518 7.91762 21 10.2068 21 12.5937Z"
      :fill="fill"
    />
    <path
      d="M12 2.84375C10.0716 2.84375 8.18657 3.41558 6.58319 4.48692C4.97982 5.55826 3.73013 7.08101 2.99218 8.86259C2.25422 10.6442 2.06114 12.6046 2.43735 14.4959C2.81355 16.3872 3.74215 18.1245 5.10571 19.488C6.46928 20.8516 8.20656 21.7802 10.0979 22.1564C11.9892 22.5326 13.9496 22.3395 15.7312 21.6016C17.5127 20.8636 19.0355 19.6139 20.1068 18.0106C21.1782 16.4072 21.75 14.5221 21.75 12.5937C21.7473 10.0087 20.7192 7.53036 18.8913 5.70247C17.0634 3.87459 14.585 2.84648 12 2.84375ZM12 20.8437C10.3683 20.8437 8.77326 20.3599 7.41655 19.4534C6.05984 18.5469 5.00242 17.2584 4.378 15.7509C3.75358 14.2434 3.5902 12.5846 3.90853 10.9843C4.22685 9.38391 5.01259 7.9139 6.16637 6.76012C7.32016 5.60634 8.79017 4.8206 10.3905 4.50227C11.9909 4.18394 13.6497 4.34732 15.1571 4.97174C16.6646 5.59617 17.9531 6.65359 18.8596 8.01029C19.7662 9.367 20.25 10.9621 20.25 12.5937C20.2475 14.781 19.3775 16.878 17.8309 18.4246C16.2843 19.9713 14.1873 20.8413 12 20.8437ZM16.2806 10.5631C16.3504 10.6328 16.4057 10.7155 16.4434 10.8065C16.4812 10.8976 16.5006 10.9952 16.5006 11.0937C16.5006 11.1923 16.4812 11.2899 16.4434 11.381C16.4057 11.472 16.3504 11.5547 16.2806 11.6244L12.5306 15.3744C12.461 15.4441 12.3783 15.4994 12.2872 15.5372C12.1962 15.5749 12.0986 15.5943 12 15.5943C11.9014 15.5943 11.8038 15.5749 11.7128 15.5372C11.6218 15.4994 11.539 15.4441 11.4694 15.3744L7.71938 11.6244C7.57865 11.4836 7.49959 11.2928 7.49959 11.0937C7.49959 10.8947 7.57865 10.7039 7.71938 10.5631C7.86011 10.4224 8.05098 10.3433 8.25 10.3433C8.44903 10.3433 8.6399 10.4224 8.78063 10.5631L12 13.7834L15.2194 10.5631C15.289 10.4934 15.3718 10.4381 15.4628 10.4003C15.5538 10.3626 15.6514 10.3432 15.75 10.3432C15.8486 10.3432 15.9462 10.3626 16.0372 10.4003C16.1283 10.4381 16.211 10.4934 16.2806 10.5631Z"
      :fill="fill"
      :class="rotate"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsArrowCircle'
})

const props = defineProps({
  direction: {
    type: String,
    default: 'right',
    validator: value => ['right', 'left', 'top', 'bottom'].includes(value)
  },
  fill: {
    type: String,
    default: '#CBFE50'
  }
})

const rotate = computed(() => {
  const rotationMap = {
    right: '-rotate-90',
    top: '-rotate-180',
    left: 'rotate-90',
    bottom: 'rotate-0'
  }

  return `${rotationMap[props.direction]} origin-center`
})
</script>
